import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm">
            关于91社区，你可能想知道的事
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openId === faq.id ? "ri-subtract-line rotate-180" : "ri-add-line"
                  }`}
                ></i>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}